import React from "react";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GIEButton from '../GIEButton/GieButton';
import HeaderMobile from './HeaderMobile';
import logo from "../../assets/gie.png";
import greyWarning from '../../assets/img/icons/greyWarning.svg';
import logout from "../../assets/img/icons/logout.svg";
import PersonIcon from '@material-ui/icons/Person';
import FolderIcon from '@material-ui/icons/Folder';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import userInformations from '../../userInformation/user_informations';
import './Header.css';
import GIESvgIcon from "../GIEIcon/GIESvgIcon";

class Header extends React.Component<any, any> {
  userNo: string;

  constructor(props) {
    super(props)
    this.state = {
      openMyAccount: false,
      anchorEl: null
    }

    this.userNo = userInformations.getUserNo();
  }

  goService = () => {
    window.location.href = "/admin/services"
  }

  openAccount = (event) => {
    this.setState({openMyAccount: !this.state.openMyAccount, anchorEl: event.currentTarget});
  }

  handleClose = (event) => {
    this.setState({openMyAccount: false});
    if (typeof event === 'string') {
      window.location.href = event
    }
  }

  render() {
    const {openMyAccount, anchorEl} = this.state;
    return (
      <div>
        <div className="d-none d-lg-block">
          <div className="header-wrapper">
            <a href="/admin/accueil">
              <img alt="https://gie-sa.fr" src={logo} width="180px"/>
            </a>

            <div></div>

            <div className="d-flex justify-content-end gap-3">
              {this.userNo && <>
                  <a href="/admin/formulaire-d-urgence">
                      <GIEButton classes={{root: 'white-btn'}}>
                          <div className="d-flex align-items-center gap-2">
                              <GIESvgIcon icon={greyWarning}/>
                              <span>SIGNALER UNE PANNE</span>
                          </div>
                      </GIEButton>
                  </a>
                  <GIEButton onClick={this.goService} classes={{root: 'blue-btn'}}>
                      <span>Services en ligne</span>
                      <ExpandMoreIcon/>
                  </GIEButton>
              </>}
              {!this.userNo && <a href="replanification" className="d-flex align-items-center">
                  <GIESvgIcon icon={logout}/>
                  <a className="fw-bold" href="replanification">Déconnexion</a>
              </a>}
              {this.userNo && <>
                  <GIEButton classes={{root: 'orange-btn'}} onClick={this.openAccount}
                             aria-controls="simple-menu" aria-haspopup="true">
                      <span>Mon compte</span>
                      <ExpandMoreIcon/>
                  </GIEButton>
                  <Menu id="simple-menu"
                        keepMounted
                        open={openMyAccount}
                        onClose={this.handleClose}
                        anchorEl={anchorEl}
                        style={{marginTop: '55px'}}>
                      <MenuItem>
                          <div className="d-flex align-items-center">
                              <PersonIcon className="color-primary"/>
                              <a className="fw-bold ms-2" href="mes-informations">Mes informations</a>
                          </div>
                      </MenuItem>
                      <MenuItem>
                          <div className="d-flex align-items-center">
                              <FolderIcon className="color-primary"/>
                              <a className="fw-bold ms-2" href="documents">Mes documents</a>
                          </div>
                      </MenuItem>
                      <MenuItem>
                          <div className="d-flex align-items-center">
                              <ExitToAppIcon className="color-primary"/>
                              <a className="fw-bold ms-2" href="login">Déconnexion</a>
                          </div>
                      </MenuItem>
                  </Menu></>}
            </div>
          </div>
        </div>
        <div className="d-lg-none">
          <HeaderMobile/>
        </div>
      </div>
    );
  }
}

export default Header;
